"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateContentWidth = void 0;
var STATIC_ICON_COUNT_WEIGHT = 40;
var DEFAULT_COLUMN_PADDING = 30;
var ColumnPaddings = {
    MOBILE: 8,
    TABLET: 10,
    DESKTOP: DEFAULT_COLUMN_PADDING
};
var calculateContentWidth = function (args) {
    var baseContentWidth = STATIC_ICON_COUNT_WEIGHT * Math.max(args.staticIcons, 0) +
        (args.extraWidth || 0);
    return Object.entries(args.columns).reduce(function (contentWidth, _a, columnIndex) {
        var nextColKey = _a[0], nextColLength = _a[1];
        var columnWidth = Math.max(8, nextColLength + resolveColumnPadding(args.viewportSize));
        if (typeof args.onColumnWidthCalc === 'function')
            args.onColumnWidthCalc({
                columnKey: nextColKey,
                columnWidth: columnWidth,
                columnIndex: columnIndex
            });
        return contentWidth + columnWidth;
    }, baseContentWidth);
};
exports.calculateContentWidth = calculateContentWidth;
var resolveColumnPadding = function (viewportSize) {
    return viewportSize ? ColumnPaddings[viewportSize] : DEFAULT_COLUMN_PADDING;
};
